<template>
  <div
    v-if="appointment"
    class="col-12"
  >
    <div class="grid">
      <div class="col-12 md:col-3 p-0 align-self-center">
        <span class=" appointment-time px-3 ">
          <p><strong>{{ startTime(appointment.start) }}-{{ endTime(appointment.end) }}</strong> - {{ $t(appointmentStatus.getDisplayKeyByStatus(appointment.status)) }}</p>
        </span>
      </div>
      <div class="col-12 md:col-3">
        <div v-if="appointment.office">
          <p>{{ $t('entity.site.site') }} :</p>
          <p><strong>{{ appointment.office.site.name }}</strong></p>
        </div>
        <div v-else>
          <p>{{ $t('entity.appointment.roamingTeam') }}</p>
          <p><strong>{{ appointment.roamingTeam.name }}</strong></p>
        </div>
      </div>
      <div class="col-12 md:col-2">
        <div v-if="appointment.office">
          <p>{{ $t('entity.office.office') }} : </p>
          <p><strong>{{ appointment.office?.name }}</strong></p>
        </div>
      </div>
      <div class="col-12 md:col-2 justify-content-center align-self-center">
        <Button
          :label="$t('action.overview')"
          icon="pi pi-eye"
          class="p-button-rounded p-button-outlined col-12"
          @click="openDetailDialog"
        />
      </div>
      <div class="col-12 md:col-2 justify-content-center align-self-center">
        <Button
          v-if="isUpcoming && isNotCanceled"
          :label="$t('action.cancel')"
          icon="pi pi-times"
          class="p-button-rounded p-button-outlined p-button-secondary col-12"
          @click="openCancelDialog"
        />
      </div>
    </div>
  </div>

  <AppointmentDetailDialog
    v-if="appointment"
    v-model:visible="detailDialog"
    :appointment="appointment"
  />

  <AppointmentCancelDialog
    v-model:visible="dialogCancel"
    :appointment="appointment"
    @cancel="onCancel"
  />
</template>

<script>
import Button from 'primevue/button';

import {getEndTime, getStartTime} from "@/shared/utils/dateTimeUtils";
import {ADMIN_ROLE, AGENT_ROLE} from "@/shared/constants";
import AppointmentDetailDialog from "@/components/appointments/AppointmentDetailDialog";
import moment from "moment-timezone";
import AppointmentCancelDialog from "@/components/appointments/AppointmentCancelDialog";
import useAppointmentStatus from "@/composables/useAppointmentStatus";

export default {
  name: 'AppointmentComponent',
  components: { AppointmentCancelDialog, AppointmentDetailDialog, Button },
  props: {
    appointment: {
      type: Object,
      required: true
    },
  },
  emits: ['update'],
  setup() {
    const appointmentStatus = useAppointmentStatus();
    return {
      appointmentStatus
    }
  },
  data() {
    return {
      dialogCancel: false,
      detailDialog: false,
    }
  },
  computed: {
    isUpcoming() {
      const timezone = this.appointment.office?.site?.timezone;
      const startTz = timezone ? moment.tz(this.appointment.start, timezone) : moment(this.appointment.start);
      return startTz.isAfter(moment());
    },
    isNotCanceled() {
      return this.appointment.status !== this.appointmentStatus.CANCELED;
    },
    isAgent() {
      return this.$store.state.auth.user && (this.$store.state.auth.user.role === AGENT_ROLE || this.$store.state.auth.user.role === ADMIN_ROLE)
    },
  },
  methods: {
    startTime(time) {
      return getStartTime(time, this.$i18n.locale)
    },
    endTime(time) {
      return getEndTime(time, this.$i18n.locale)

    },
    openDetailDialog() {
      this.detailDialog = true
    },
    async openCancelDialog() {
      this.dialogCancel = true
    },
    onCancel() {
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss" scoped>
.appointment-time {
  background-color: $light-grey;
  display: inline-block;
}
</style>
